import { render, staticRenderFns } from "./PageKChip.vue?vue&type=template&id=3bf25758"
import script from "./PageKChip.vue?vue&type=script&lang=js"
export * from "./PageKChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports